import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GetPastSensorsDocument } from '@/graphql/types';

export function usePastSensors(measuringPointId: string) {
    const [fetchPastSensors, { data, loading }] = useLazyQuery(GetPastSensorsDocument, {
        fetchPolicy: 'cache-first',
    });

    const loadPastSensors = useCallback(() => {
        void fetchPastSensors({
            variables: { id: measuringPointId },
        });
    }, [fetchPastSensors, measuringPointId]);

    return {
        // Undefined until loaded; a fresh `[]` fallback would change on every render.
        pastSensors: data?.measuringPointById?.pastSensors,
        loadPastSensors,
        loading,
    };
}
